import { render, staticRenderFns } from "./ModalDeleteNote.vue?vue&type=template&id=6f399992"
import script from "./ModalDeleteNote.vue?vue&type=script&lang=js"
export * from "./ModalDeleteNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports